import { render, staticRenderFns } from "./integrations.vue?vue&type=template&id=95a9e22e&scoped=true"
import script from "./integrations.vue?vue&type=script&lang=js"
export * from "./integrations.vue?vue&type=script&lang=js"
import style0 from "./integrations.vue?vue&type=style&index=0&id=95a9e22e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a9e22e",
  null
  
)

export default component.exports